import graphql__357b5842b7ae09fdfd85 from "./__generated__/ContributionsDatavizGraphThemeRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams, useOutletContext } from "react-router";
import AppQueryRenderer from "../AppQueryRenderer";

import ContributionsDatavizGraphTheme from "../ParticipativeModule/Visualizations/ContributionsDataviz/ContributionsDatavizGraphTheme";
import { ResourcesListProvider } from "../ResourcesList/resourcesList";
import ResourcesListUrlSearchSync from "../ResourcesList/ResourcesListUrlSearchSync";

const ContributionsDatavizGraphThemeRoute = props => {
  const { participativeModuleSlug, themeSlug } = useParams();
  const { contributionsPerPage: contributionsCount } = useOutletContext();

  return (
    <AppQueryRenderer
      query={ContributionsDatavizGraphThemeRouteQuery}
      variables={{ participativeModuleSlug, themeSlug, contributionsCount }}
      additionalProps={props}
    >
      {props => (
        <ResourcesListProvider key={themeSlug}>
          <ResourcesListUrlSearchSync />
          <ContributionsDatavizGraphTheme {...props} />
        </ResourcesListProvider>
      )}
    </AppQueryRenderer>
  );
};

const ContributionsDatavizGraphThemeRouteQuery = graphql__357b5842b7ae09fdfd85;

export default ContributionsDatavizGraphThemeRoute;
